"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handle401Result = handle401Result;
exports.setActiveSession = setActiveSession;
exports.enableSessionExpiredHandler = enableSessionExpiredHandler;

var _urlHelper = require("./url-helper");

var hasActiveSession = false;

function handle401Result(loginUrl) {
  // When this handler is not enabled, just redirect the user to login page
  if (window.sessionExpiredHandlerEnabled !== true) {
    window.location.href = loginUrl || (0, _urlHelper.getLoginUrl)();
    return;
  } // When we had an active session, trigger a post message so we can show a popup modal
  // We need this to prevent showing the popup for public pages/accessing a private page without a session cookie


  if (hasActiveSession) {
    window.postMessage({
      type: 'session_expired',
      message: {}
    }, window.document.origin);
    return;
  } // Fallback to redirect back to login page


  window.location.href = (0, _urlHelper.getLoginUrl)();
}
/**
 * Set that this session is active and has a valid login session.
 * @param {bool} isActive Set this to true if the user is logged in
 */


function setActiveSession(isActive) {
  hasActiveSession = isActive;
}
/**
 * You can enable or disable the session expired handler here.
 * @param {bool} enabled Enable (or disable) the session expired handler
 */


function enableSessionExpiredHandler() {
  var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  window.sessionExpiredHandlerEnabled = enabled;
}